import { getTimeSpaceArray } from '@op/utils';
import { DBO_TM } from '@op/utils/format';
import { isSameTime } from '@op/utils/time';
import { TServerDateType } from '@opm/types/common';
import moment from 'moment';

export const saveFilterDateMap: { [key in TServerDateType]?: any } = {
  daily: {
    formate: 'YYYY-MM-DD',
    moment_type: 'day',
    before_text: 'Yesterday',
    suffix: 'Days',
    current: 'Today',
  },
  weekly: {
    formate: 'YYYY-MM-DD',
    moment_type: 'week',
    before_text: 'Last Week',
    suffix: 'Weeks',
    current: 'This Week',
  },
  monthly: {
    formate: 'YYYY-MM',
    moment_type: 'month',
    before_text: 'Last Month',
    suffix: 'Months',
    current: 'This Month',
  },
};

export const dealwithDate = (
  startTime: string,
  endTime: string,
  dateType: TServerDateType = 'daily',
) => {
  const { formate, moment_type } = saveFilterDateMap[dateType] || saveFilterDateMap.daily;
  const currentDate = moment().subtract(1, 'day').format(formate); // 当前时间
  const beforeDate = moment().subtract(1, moment_type).format(formate); // 前一周期时间

  const sameTimeFun = isSameTime(dateType);

  if (sameTimeFun(currentDate, endTime) && !sameTimeFun(startTime, endTime)) {
    const times = getTimeSpaceArray(
      startTime,
      endTime,
      moment_type,
      formate,
      true,
    );
    return times.length;
  }
  if (sameTimeFun(beforeDate, endTime) && sameTimeFun(startTime, endTime)) {
    return -1;
  }
  return 0;
};

export const resumeDateTime = (filter: {
  start_time: string;
  end_time: string;
  date_type: TServerDateType;
  time_value: number;
}) => {
  const {
    start_time,
    end_time,
    date_type = 'daily',
    time_value,
  } = filter || {};


  function backParamsInfo(times: [string, string]) {
    return {
      start_time: times[0],
      end_time: times[1],
    };
  }

  const { formate, moment_type } = saveFilterDateMap[date_type] || {
    formate: 'YYYY-MM-DD HH:mm:ss',
  };
  const current = moment().format(formate);
  if (typeof time_value === 'string' && time_value === 'Year to Date') {
    const start_time = moment(`${moment().year()}-01-01`).format(formate);
    const end_time =
      (moment(`${moment().year()}-01-01`).format(formate), current);
    return backParamsInfo(DBO_TM.serverTime([start_time, end_time], 'daily'));
  }

  if (time_value === 0 || time_value === -1) {
    let startDate = null;
    let endDate = null;
    if (moment_type === 'week') {
      startDate = moment()
        .week(moment().week() + time_value)
        .startOf('week')
        .add(0, 'days')
        .format(formate);
      endDate = moment()
        .week(moment().week() + time_value)
        .endOf('week')
        .add(0, 'days')
        .format(formate);
    } else if (moment_type === 'month') {
      startDate = moment()
        .month(moment().month() + time_value)
        .startOf('month')
        .format(formate);
      endDate = moment()
        .month(moment().month() + time_value)
        .endOf('month')
        .format(formate);
    } else {
      // eslint-disable-next-line no-multi-assign
      endDate = startDate = moment().format(formate);

      if (time_value === -1) {
        // eslint-disable-next-line no-multi-assign
        endDate = startDate = moment(startDate)
          .subtract(1, 'day')
          .format(formate);
      }
    }
    return backParamsInfo(DBO_TM.serverTime([startDate, endDate], 'daily'));
  }

  if (time_value > 0) {
    return backParamsInfo(
      DBO_TM.serverTime(
        [
          moment()
            .subtract(time_value, moment_type)
            .format(formate),
          moment().subtract(1, moment_type).format(formate),
        ],
        'daily',
      ),
    );
  }

  return { start_time, end_time };
};
